import apiManager from '../AxiosInstance';

export const createChatMessages = async (formData: FormData) => {
  const response = await apiManager.post('api/v1/chat-messages', formData);
  return response.data;
};
